module.exports = __webpack_public_path__ + "static/media/21ECLAC2.e6b51c02.jpg";